import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
export default new Router({
    routes: [
        {path: '/index', redirect: '/post/news'},
        {
            path: '/setting', component: () => import('./views/setting/Setting'), children: [
                {path: '', redirect: '/setting/parameter'},
                {path: 'index', redirect: '/setting/parameter'},
                {path: 'parameter', redirect: '/setting/parameter/app-version'},
                {path: 'etc', props: true, component: () => import('./views/setting/parameter/Etc')},
                {path: 'parameter/:type', props: true, component: () => import('./views/setting/parameter/Parameter')},
                {path: 'profile', component: () => import('./views/setting/account-info/Profile')},
                {path: 'device-token', component: () => import('./views/setting/account-info/DeviceToken')},
                {path: 'staff', component: () => import('./views/setting/roles-and-users/Staff')},
                {path: 'action-define', component: () => import('./views/setting/roles-and-users/Define')},
                {path: 'roles', component: () => import('./views/setting/roles-and-users/Roles')},
                {path: 'roles/:id', props: true, component: () => import('./views/setting/roles-and-users/Role')},
                {path: 'notify', component: () => import('./views/setting/Notify')},
                {path: 'email', component: () => import('./views/setting/communication/email/Email')},
                {path: 'client', component: () => import('./views/setting/client/Client')},
                {path: 'dashboard', component: () => import('./views/setting/client/Dashboard')},
                {path: 'staff-activity', component: () => import('./views/setting/history/StaffActivity')},
                {path: 'emailoutbox', component: () => import('./views/setting/history/Emailoutbox')},
                {path: 'notify', component: () => import('./views/setting/history/Notify')},
            ]
        },
        {
            path: '/page', component: () => import('./views/page/Setting'), children: [
                {path: '', redirect: '/page/index'},
                {path: 'index', redirect: '/page/home'},
                {path: 'home', component: () => import('./views/page/home/Home.vue')},
                {path: 'data', component: () => import('./views/page/data/Index')},
            ]
        },
        {
            path: '/post', component: () => import('./views/post/Setting'), children: [
                {path: '', redirect: '/post/news'},
                {path: 'index', redirect: '/post/news'},
                {path: 'category', component: () => import('./views/post/Category')},
                {path: 'news', component: () => import('./views/post/News')},
                {path: 'policy', component: () => import('./views/post/Policy')},
                {path: 'create', component: () => import('./views/post/Form')},
                {path: 'update/:id', props: true, component: () => import('./views/post/Form')},
                {path: 'comment', component: () => import('./views/post/Comment')},
            ]
        },
        {path: '/keyword', component: () => import('./views/keyword/Setting'),children: [
            {path: '', redirect: '/keyword/Index'},
            {path: 'index', component: () => import('./views/keyword/Index.vue')},
            ]
        },
        {path: '/public-service', component: () => import('./views/public-service/Setting'),children: [
            {path: '', redirect: '/public-service/Index'},
            {path: 'index', component: () => import('./views/public-service/Index')},
            {path: 'create', component: () => import('./views/public-service/Form')},
            {path: 'update/:id', props: true, component: () => import('./views/public-service/Form')},
            {path: 'field', component: () => import('./views/public-service/Field')},
            ]
        },
        {path: '/place-green', component: () => import('./views/place-green/Setting'),children: [
            {path: '', redirect: '/place-green/Index'},
            {path: 'index', component: () => import('./views/place-green/Index')},
            ]
        },
        {path: '/data', component: () => import('./views/data/Setting'),children: [
            {path: '', redirect: '/data/Index'},
            {path: 'index', component: () => import('./views/data/CustomFields')},
            {path: 'trash', component: () => import('./views/data/CustomFields')},
            {path: 'greenhub', component: () => import('./views/data/Greenhub')},
            {path: 'classify', component: () => import('./views/data/Classify')},
            ]
        },
        {path: '/environment', component: () => import('./views/environment/Setting'),children: [
            {path: '', redirect: '/environment/Index'},
            {path: 'index', redirect: '/environment/client'},
            {path: 'client', component: () => import('./views/environment/Client')},
            {path: 'licensing', component: () => import('./views/environment/Licensing')},
            {path: 'break', component: () => import('./views/environment/Break')},
            {path: 'ward', component: () => import('./views/environment/Ward')},
            ]
        },
        {path: '/monitoring', component: () => import('./views/monitoring/Setting'),children: [
            {path: '', redirect: '/monitoring/Index'},
            {path: 'index', component: () => import('./views/monitoring/PlaceMonitoring')},
            {path: 'place', component: () => import('./views/monitoring/PlaceMonitoring')},
            {path: 'target', component: () => import('./views/monitoring/TargetMonitoring')},
            {path: 'standard', component: () => import('./views/monitoring/StandardMonitoring')},
            {path: 'data', component: () => import('./views/monitoring/DataMonitoring')},
            // {path: 'greenhub', component: () => import('./views/data/Greenhub')},
            // {path: 'classify', component: () => import('./views/data/Classify')},
            ]
        },
        {path: '/use/:token', component: () => import('./views/UseUser'), props: true},
        {path: '/login', component: () => import('./views/auth/Login')},
        {path: '/forgot', component: () => import('./views/auth/Forgot')},
        {path: '/reset/:token', component: () => import('./views/auth/Reset'), props: true},
        {path: '*', redirect: '/index'},
        {path: '/', redirect: '/index'}
    ],
})
